module.exports = __webpack_public_path__ + "media/images/dropdown-3d43716e8e18204ae36dfbbcb8d5f31f.svg";